module.exports = __webpack_public_path__ + "img/ro6.78f1b719.jpg";